import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Store } from "@ngrx/store";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { DatePickerModule } from "primeng/datepicker";
import { SelectModule } from "primeng/select";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import {
  AgentTask,
  TaskStatusEnum,
} from "src/app/shared/models/agent-tasks.model";
import { Clinic } from "src/app/shared/models/clinic.model";
import { DataElement } from "src/app/shared/models/common";
import { UiUser } from "src/app/shared/models/ui-user.model";
import {
  chatTaskStatusList,
  clinicList,
  generalTaskUsersList,
} from "src/app/shared/ngrx/ngrx-selectors";
import { AppState } from "src/app/shared/redux/store";
import { AuthService } from "src/app/shared/services/auth.service";
import { BroshService } from "src/app/shared/services/brosh.service";
import { SharedService } from "src/app/shared/services/shared.service";

@Component({
  selector: "edit-agent-task",
  templateUrl: "./edit-agent-task.component.html",
  styleUrls: ["./edit-agent-task.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputWrapComponent,
    TranslateModule,
    SelectModule,
    DatePickerModule,
  ],
})
export class EditAgentTaskComponent {
  @Input() task: AgentTask;
  @Output() onCancel = new EventEmitter();
  @Output() onSave = new EventEmitter();

  saving: boolean;
  calLocale = {};

  get isNew(): boolean {
    return !this.task.taskId;
  }

  get clinicList(): Clinic[] {
    return this.store.selectSignal(clinicList)();
  }

  get taskUsersList(): UiUser[] {
    return this.store.selectSignal(generalTaskUsersList)();
  }

  get statusList(): DataElement[] {
    return this.store.selectSignal(chatTaskStatusList)();
  }

  get taskUserSw(): boolean {
    return false;
  }

  constructor(
    private readonly store: Store,
    private broshService: BroshService,
    private authService: AuthService,
    private translateService: TranslateService,
    private sharedService: SharedService
  ) {
    this.translateService.get("calLocale").subscribe((data) => {
      this.calLocale = data;
    });
  }

  ngOnInit(): void {
    if (this.task.taskUser) {
      this.task.taskUser = this.taskUsersList.find(
        (u) => u.userId == this.task.taskUser.userId
      );
    }
  }

  public closePanel() {
    this.onCancel.emit();
  }

  saveEnabled() {
    return this.task.title && this.task.clinic && this.task.taskUser;
  }

  completeTask() {
    this.task.status = this.statusList.find(
      (s) => s.id == TaskStatusEnum.CLOSED
    );
    this.save();
  }

  save() {
    console.log(this.task);
    this.saving = true;
    this.broshService.updAgentTask(this.task).subscribe(
      (data) => {
        this.saving = false;
        this.onSave.emit();
      },
      (error) => {
        this.saving = false;
        this.sharedService.alertError(error);
      }
    );
  }
}
